import { Grid, Paper } from '@mui/material';
import React from 'react';
import AddButton from '../../Buttons/AddButton';
import { Language } from '../../../store/languages/types';
import { ValueGroups } from '../../StageZero/types';
import '../Values/Value.scss';
import { autoId } from '../../../utils/UidGenerator';
import DeleteButton from '../../Buttons/DeleteButton';
import { TextField } from '@mui/material';

interface ValueGroupsContainerProps {
    language: string;
    languages: Language[];
    valueGroups: ValueGroups[];
    setValueGroups: React.Dispatch<React.SetStateAction<ValueGroups[]>>;
    deleteEnabled?: boolean;
}

const ValueGroupsContainer: React.FC<ValueGroupsContainerProps> = (props) => {
    const createNewItem = () => {
        return { id: autoId(), name: null } as ValueGroups;
    };

    const handleAddValueGroup = () => {
        props.setValueGroups([...props.valueGroups, createNewItem()]);
    };

    const handleRemoveValueGroup = (id?: string) => {
        const updatedValueGroups = props.valueGroups.filter((x) => x.id !== id);
        props.setValueGroups(updatedValueGroups);
    };

    const updateName = (valueGroupId: string, e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        const splitetName = name.split('_');
        const property = splitetName[0];
        const language = splitetName[1];
        const updateValueGroup = props.valueGroups.find((x) => x.id === valueGroupId) ?? {};
        const oldValue = Object.entries(updateValueGroup).find((x) => x[0] === property)?.[1] as object;
        const newValue = { ...oldValue, [language]: value };
        props.setValueGroups((prevState) =>
            prevState.map((value) => (value.id === valueGroupId ? { ...value, [property]: newValue } : value)),
        );
    };

    return (
        <Grid container spacing={2}>
            {props.languages.map((lang) => (
                <Grid item xs={12} key={lang.code} style={{ display: lang.code === props.language ? 'block' : 'none' }}>
                    <h2>{'Value groups'}</h2>
                    <Paper className="value-container">
                        {props.valueGroups?.map((value) => {
                            return (
                                <div className="value-item-delete" key={`value_${value.id}`}>
                                    {props.deleteEnabled && (
                                        <DeleteButton action={() => handleRemoveValueGroup(value.id)} size="small" />
                                    )}
                                    <TextField
                                        fullWidth
                                        className="name-value-field"
                                        key={`name_${props.language}`}
                                        defaultValue={value.name?.[props.language]}
                                        variant="outlined"
                                        type="text"
                                        id={`name_${props.language}`}
                                        label="Value name"
                                        name={`name_${props.language}`}
                                        onChange={(e) => updateName(value.id, e)}
                                    ></TextField>
                                </div>
                            );
                        })}
                        <div className="add-button-container">
                            <AddButton action={handleAddValueGroup}></AddButton>
                        </div>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
};

export default ValueGroupsContainer;
